import FooterBrandColumn from './footer/FooterBrandColumn';
import FooterLinksColumn, { FooterColumnHeading } from './footer/FooterLinksColumn';
import FooterNewsletter from './footer/FooterNewsletter';
import FooterBottomBar from './footer/FooterBottomBar';
import { PLATFORM_LINKS, SOLUTIONS_LINKS, ABOUT_LINKS, REGULATORY_LINKS } from './footer/footerData';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0A1628' }} className="text-white" data-testid="site-footer">
      <div className="section-padding">
        <div className="max-w-content mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-16">

            <FooterBrandColumn />

            <div>
              <FooterColumnHeading>Platform</FooterColumnHeading>
              <FooterLinksColumn links={PLATFORM_LINKS} />
            </div>

            <div>
              <FooterColumnHeading>Solutions</FooterColumnHeading>
              <FooterLinksColumn links={SOLUTIONS_LINKS} />
            </div>

            <div>
              <FooterColumnHeading>About MCX</FooterColumnHeading>
              <FooterLinksColumn links={ABOUT_LINKS} />
            </div>

            <div>
              <FooterColumnHeading>Regulatory &amp; Legal</FooterColumnHeading>
              <div className="mb-8">
                <FooterLinksColumn links={REGULATORY_LINKS} />
              </div>
              <FooterNewsletter />
            </div>
          </div>

          <FooterBottomBar />
        </div>
      </div>
    </footer>
  );
}
